import thunk              from 'redux-thunk';
import promise            from 'redux-promise';
import { persistStore, 
         persistReducer } from 'redux-persist';
import storage            from 'redux-persist/lib/storage'; // defaults to localStorage for web and AsyncStorage for react-native
import { createStore,
         applyMiddleware,
         compose }        from 'redux';
import reducers           from '../reducers';

const persistConfig = {
    key: 'root',
    storage,
    blacklist:['auth','form','scopoReducer','notificacaoReducer']
  }
  const persistedReducer = persistReducer(persistConfig, reducers);
  const store = createStore(
                persistedReducer,
                compose(
                  applyMiddleware(promise,thunk),
                  window.devToolsExtension ? window.devToolsExtension() : f => f
                )
  );
  
  const persistor = persistStore(store);

  export  { store, persistor };


// WEBPACK FOOTER //
// ./src/utils/store.js